/**
 * @file Service worker registration (push notifications).
 */

import { isPortfolioHost } from "./portfolio-host";

/**
 * Register `/sw.js` once the page has loaded. Skipped on the marketing-domain
 * portfolio host (EPD-10104): a root-scoped worker there would take over the
 * whole marketing site, and the portfolio page has no use for push.
 */
export function registerServiceWorker(win: Window = window): void {
  if (!("serviceWorker" in win.navigator)) return;
  if (isPortfolioHost(win.document)) return;

  const register = () => {
    win.navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((error) => {
        // Non-critical — push notifications degrade gracefully without SW.
        // Use console.warn to avoid surfacing as an error in Datadog RUM.
        console.warn("Service Worker registration failed:", error);
      });
  };
  // A late call (page already loaded) would otherwise never see `load`.
  if (win.document.readyState === "complete") register();
  else win.addEventListener("load", register);
}
